import { AssignmentLeaveTypeEnum, ConfigurationInterface, FeatureEnum, FeatureFlagEnum } from '@nutt/configuration';

export const configuration: Readonly<ConfigurationInterface> = {
  tenant: { brand: 'Morrenhof-Jansen', logoUrl: 'assets/logo-text.png' },

  // This list is alphabetically sorted by name and should be kept that way since there is
  // no sorting in the components this is being used.
  branches: [
    { name: 'ATSnl', value: 'ATS' },
    { name: 'CIUS', value: 'YST' },
    { name: 'Dick Sjabbens', value: 'DIE' },
    { name: 'Energie Quartier', value: 'ENQ' },
    { name: 'Huisman Installatietechniek', value: 'HUI' },
    { name: 'Janssen Klimaattechniek', value: 'HOO' },
    { name: 'Lumio', value: 'LUM' },
    { name: 'MJ Dalfsen', value: 'DAL' },
    { name: 'MJ Enschede', value: 'ECH' },
    { name: 'MJ Gramsbergen', value: 'GRA' },
    { name: 'MJ IJsselmuiden', value: 'YSS' },
    { name: 'MJ Service', value: 'SVC' },
    { name: 'MJ Vriezenveen', value: 'VRI' },
    { name: 'Modus Regeltechniek', value: 'MOD' },
    { name: 'Pensionado’s', value: 'PEN' },
    { name: 'Solar Today', value: 'ZWO' },
    { name: 'TechniekMakers', value: 'TM' },
    { name: 'TechniekWijzer', value: 'TW' },
    { name: 'Vesting Groep', value: 'VG' },
    { name: 'Waterrijk Zwembadtechniek', value: 'SRV' },
  ],

  features: [
    // The form feature is never properly tested beyond its pilot phase, so it is disabled for now.
    { feature: FeatureEnum.Forms, isDisabled: true },
    { feature: FeatureEnum.Compensation, isDisabled: true },
    {
      feature: FeatureEnum.Employees,
      flags: {
        [FeatureFlagEnum.LinkedWithLoket]: true,
        [FeatureFlagEnum.ChildrenField]: true,
        [FeatureFlagEnum.LeaveBalance]: true,
      },
    },
    {
      feature: FeatureEnum.News,
      flags: { [FeatureFlagEnum.ShowOnNarrowcasting]: true },
    },
    {
      feature: FeatureEnum.Planning,
      flags: { [FeatureFlagEnum.DefaultWholeDay]: true, [FeatureFlagEnum.CanTransferEmployees]: true },
      metadata: {
        assignableLeaveTypes: [
          AssignmentLeaveTypeEnum.School,
          AssignmentLeaveTypeEnum.Sick,
          AssignmentLeaveTypeEnum.Leave,
          AssignmentLeaveTypeEnum.Doctor,
          AssignmentLeaveTypeEnum.ParentLeave,
        ],
        defaultStartOfWorkDay: '07:30',
        defaultEndOfWorkDay: '16:15',
      },
    },
    {
      feature: FeatureEnum.Hours,
      flags: { [FeatureFlagEnum.CanManageHours]: true },
    },
  ],
};
